import { useState, useContext } from "react";
import {
  Typography,
  Box,
  Grid,
  Table,
  Chip,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TableContainer,
} from "@mui/material";
//Import from project
import "../../../Style/pagestyle.scss";
import { AuthContext } from "../../../Context/AuthContext";
import { ButtonCreate } from "../../../Utils/Component";
import EmptyData from "../../../Components/Include/EmptyData/EmptyData";
import LoadingPage from "../../../Utils/LoadingPage";
import useGetPackagePricePagination from "../../../Hooks/useGetPackagePricePagination";
import { SelectClassGroupFee } from "../../../Components/Include/DynamicSelect/DynamicSelect";
import FooterPagination from "../../../Utils/FooterPagination";
import useWithDimension from "../../../Hooks/useWithDimension";
import PackagePriceForm from "../../../Components/PackagePrice/PackagePriceForm";
import PackagePriceAction from "../../../Components/PackagePrice/PackagePriceAction";
import { currencyFormat } from "../../../Function/DynamicFn";

export default function PackagePrice({ classId }) {
  // Change Language
  const { t } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { width } = useWithDimension();
  const [groupFeeVal, setGroupFeeVal] = useState({ id: "", title: "" });

  const {
    page,
    limit,
    setPage,
    refetch,
    loading,
    tableData,
    setLoading,
    paginationData,
    handleLimit,
  } = useGetPackagePricePagination({
    classId: classId || null,
    groupFeeId: groupFeeVal?.id || null,
  });

  return (
    <div className="page-container">
      <Box sx={{ marginTop: "10px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_group_fee")}
            </Typography>
            <SelectClassGroupFee
              buttonAdd={false}
              value={groupFeeVal}
              onChange={setGroupFeeVal}
              className="text-field"
            />
          </Grid>
          <Grid item xs={6} sm={6} md={8} lg={9} xl={10}>
            <ButtonCreate
              handleOpen={handleOpen}
              classBtn={"btn-create"}
              classIcon={"icon-add"}
            />

            {open && (
              <PackagePriceForm
                open={open}
                setRefetch={refetch}
                dialogTitle={"Create"}
                handleClose={handleClose}
                classId={classId}
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table">
            <TableHead className="header-row">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width={"5%"}
                >
                  {t("thead_no")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title")}
                  width={"13%"}
                >
                  {t("thead_title")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title")}
                  width={"15%"}
                >
                  {t("thead_group_fee")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title")}
                  width={"13%"}
                >
                  {t("thead_duration")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title")}
                  width={"13%"}
                >
                  {t("thead_discount_type")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title")}
                  width={"10%"}
                >
                  {t("thead_discount_amount")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title")}
                  width={"12%"}
                  align="center"
                >
                  {t("thead_limit")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title-end")}
                  width={"8%"}
                ></TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={12} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 || tableData?.length === undefined ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={12} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      return (
                        <TableRow className={"body-row"} key={index}>
                          <TableCell className="body-cell-start">
                            {index + 1}
                          </TableCell>

                          <TableCell className="body-cell">
                            {row?.title}
                          </TableCell>

                          <TableCell className="body-cell">
                            {row?.groupFeeId?.title +
                              ": " +
                              `${row?.groupFeeId?.price}$`}
                          </TableCell>

                          <TableCell className="body-cell">
                            {row?.duration} {t(`thead_day`)}
                          </TableCell>

                          <TableCell className="body-cell">
                            {row?.discountType === "amount"
                              ? "Amount"
                              : "Percent"}
                          </TableCell>

                          <TableCell className="body-cell">
                            {!row?.discountAmount
                              ? "0"
                              : row?.discountType === "percent"
                                ? `${row?.discountAmount}%`
                                : `$ ${currencyFormat(row?.discountAmount)}`}
                          </TableCell>

                          <TableCell className="body-cell" align="center">
                            {/* {row?.unlimited === true ? t(`thead_unlimited`) : t(`thead_limited`)} */}
                            <Chip
                              size="small"
                              color={
                                row?.unlimited === true ? "info" : "warning"
                              }
                              label={
                                row?.unlimited === true
                                  ? t(`thead_unlimited`)
                                  : t(`thead_limited`)
                              }
                            />
                          </TableCell>

                          <TableCell className="body-cell-end" align="right">
                            <PackagePriceAction
                              editData={row}
                              setRefetch={refetch}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
